import React from "react";

const BriefCase = ({
  width = 46,
  height = 46,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="44" height="44" rx="22" fill="white" />
      <rect x="1" y="1" width="44" height="44" rx="22" stroke="#E2E4E9" />
      <path
        d="M25.7 14.8984C26.1968 14.8984 26.6 15.3016 26.6 15.7984V17.5984H31.1C31.5968 17.5984 32 18.0016 32 18.4984V30.1984C32 30.6952 31.5968 31.0984 31.1 31.0984H14.9C14.4032 31.0984 14 30.6952 14 30.1984V18.4984C14 18.0016 14.4032 17.5984 14.9 17.5984H19.4V15.7984C19.4 15.3016 19.8032 14.8984 20.3 14.8984H25.7ZM26.6 19.3984H19.4V29.2984H26.6V19.3984ZM15.8 19.3984V29.2984H17.6V19.3984H15.8ZM24.8 16.6984H21.2V17.5984H24.8V16.6984ZM28.4 19.3984V29.2984H30.2V19.3984H28.4Z"
        fill="#525866"
      />
    </svg>
  );
};

export default BriefCase;
